import { useCallback, useState } from 'react';

import { defaultState } from './constants';

const useErrorState = () => {
  const [errorState, setErrorState] = useState(defaultState);

  const resetError = useCallback(() => setErrorState(defaultState), []);

  const setError = useCallback(
    ({ message = defaultState.message, status = defaultState.status } = {}) =>
      setErrorState({
        isError: true,
        message,
        status,
      }),
    [],
  );

  return { ...errorState, resetError, setError };
};

export default useErrorState;
